import {Store, Module, ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import Bin from '../entities/bin';
import BinDetail from '../entities/bindetail';
import BinType from '../entities/bintype'
import Aisle from '../entities/aisle'
import Room from '../entities/room'
interface BinState extends ListState<Bin>{
    editBin:Bin,
    viewBin: Bin,
    aisles: Aisle[],
    rooms : Room[],
    binTypes : BinType[]
}
class BinMutations extends ListMutations<Bin>{

}
class BinModule extends ListModule<BinState,any,Bin>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<Bin>(),
        loading:false,
        editBin:new Bin(),
        viewBin: new Bin(),
        aisles: new Array<Aisle>(),
        rooms : new Array<Room>(),
        binTypes: new Array<BinType>()
    }
    actions={
        async getAll(context:ActionContext<BinState,any>,payload:any){
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/EBin/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Bin>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async create(context:ActionContext<BinState,any>,payload:any){
            await Ajax.post('/api/services/app/EBin/Create',payload.data);
        },
        async update(context:ActionContext<BinState,any>,payload:any){
            await Ajax.put('/api/services/app/EBin/Update',payload.data);
        },
        async delete(context:ActionContext<BinState,any>,payload:any){
            await Ajax.delete('/api/services/app/EBin/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<BinState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/EBin/GetDetail?Id='+payload.data.id);
            return reponse.data.result as BinDetail;
        },
        async getBinTypes(context:ActionContext<BinState,any>){
            let reponse=await Ajax.get('/api/services/app/EBin/GetBinTypes');
            context.state.binTypes=reponse.data.result as BinType[];
        },
        async getAisles(context:ActionContext<BinState,any>){
            let reponse=await Ajax.get('/api/services/app/EBin/GetAisles');
            context.state.aisles=reponse.data.result as Aisle[];
        },
        async getRooms(context:ActionContext<BinState,any>){
            let reponse=await Ajax.get('/api/services/app/EBin/GetRooms');
            context.state.rooms=reponse.data.result as Room[];
        }
    };
    mutations={
        setCurrentPage(state:BinState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:BinState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:BinState,bin:Bin){
            state.editBin=bin;
        },
        view(state: BinState, bin:Bin) {
            state.viewBin = bin;
        }
    }
}
const binModule=new BinModule();
export default binModule;